import React from "react";
import "./carrerReport.css";
// import sampleImg from "./your-image.jpg"; // replace with your actual image

const HeroCarrerReport = () => {
  return (
    <section className="hero-carrerreport">
      {/* Left Content */}
      <div className="hero-carrerreport-content">
        {/* <h4 className="hero-carrerreport-subtitle">SPECIALITY</h4> */}
        <h1 className="hero-carrerreport-title">
          COUPLE CONSULTATION<br />
          
         <span className="carrerreporttextcolor">(COMPATIBILITY MATCHING)</span>  <br />
          {/* ANALYSIS */}
        </h1>
        <p className="hero-carrerreport-text">
Discover how aligned you truly are emotionally, mentally, and karmically.
We study both charts to reveal love patterns, compatibility, and the path to lasting harmony.        </p>
       <a href="Service"> <button className="hero-carrerreport-btn">Check your compatibility</button></a>
      </div>

      {/* Right Image */}
      <div className="hero-carrerreport-image">
        {/* <img src="/assets/carrerreportlogo.png" alt="Speciality Service" /> */}
        <img src="/assets/coupel kundli.png" alt="Speciality Service" />
      </div>
    </section>
  );
};

export default HeroCarrerReport;
